import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './component/Home.js'
import Purchase from './component/Purchase.js'
import PurchaseForm from './component/PurchaseForm.js'
import Auth from './component/Auth.js'
import AuthForm from './component/AuthForm.js'
import BizTransport from './component/BizTransport.js';
import BizTransportForm from './component/BizTransportForm.js';
import ItemBrand from './component/ItemBrand.js';
import ItemBrandForm from './component/ItemBrandForm.js';



function App() {
  return (

<Routes>
  <Route path='/' element={<Home/>} />
  <Route path='/purchase' element={<Purchase/>} />
  <Route path='/purchaseform' element={<PurchaseForm/>} />
  <Route path='/authe' element={<Home/>} />
  <Route path='/authform' element={<Home/>} />
  <Route path='/biztransport' element={<BizTransport/>} />
  <Route path='/biztransportform' element={<BizTransportForm/>} />
  <Route path='/itembrand' element={<ItemBrand/>} />
  <Route path='/itembrandform' element={<ItemBrandForm/>} />
</Routes>
  );
}

export default App;
